import Vue from 'vue'
import CoreuiVue from '@coreui/vue'
import "@coreui/coreui/scss/coreui.scss"

Vue.use(CoreuiVue)

